import { accessTypeEnum } from './../../lib/enum';

const addAccessRight = [
  accessTypeEnum.admin,
  accessTypeEnum.handlingPriceLists,
  accessTypeEnum.approvingPriceLists
];

export default addAccessRight;
